<template>
	<q-page class="q-pa-md bg-grey-2">
		<div class="row q-col-gutter-md">
			<div class="col-12">
				<q-card class="bg-primary text-white">
					<q-card-section>
						<div class="text-h4">Настройки платежей</div>
					</q-card-section>
				</q-card>
			</div>
		</div>
		<q-card class="organization-card q-pa-md">
			<q-card-section>
				<q-form @submit="onSubmit" class="q-gutter-md">
					<div class="row q-col-gutter-md">
						<div class="col-12 col-md-6">
							<q-input v-model="organization.name" label="Название организации" filled
								:rules="[val => !!val || 'Обязательное поле']" />
						</div>
						<div class="col-12 col-md-6">
							<q-input v-model="organization.address" label="Адрес" filled
								:rules="[val => !!val || 'Обязательное поле']" />
						</div>
						<div class="col-12 col-md-6">
							<q-input v-model="organization.phone" label="Номер телефона" filled mask="+7 (###) ###-####"
								:rules="[val => !!val || 'Обязательное поле']" />
						</div>
						<div class="col-12 col-md-6">
							<q-input v-model="organization.inn" label="ИНН" filled
								:rules="[val => !!val || 'Обязательное поле']" />
						</div>
						<div class="col-12 col-md-6">
							<q-input v-model="organization.kpp" label="КПП" filled
								:rules="[val => !!val || 'Обязательное поле']" />
						</div>
						<div class="col-12 col-md-6">
							<q-input v-model="organization.bank" label="Название банка" filled
								:rules="[val => !!val || 'Обязательное поле']" />
						</div>
						<div class="col-12 col-md-6">
							<q-input v-model="organization.bank_bik" label="БИК банка" filled
								:rules="[val => !!val || 'Обязательное поле']" />
						</div>
						<div class="col-12 col-md-6">
							<q-input v-model="organization.bank_account" label="Расчетный счет" filled
								:rules="[val => !!val || 'Обязательное поле']" />
						</div>
						<div class="col-12 col-md-6">
							<q-input v-model="organization.bank_account_ext" label="Кор. счет" filled
								:rules="[val => !!val || 'Обязательное поле']" />
						</div>
						<div class="col-12 col-md-6">
							<q-input v-model="organization.position_name" label="Название услуги в счете" filled
								:rules="[val => !!val || 'Обязательное поле']" />
						</div>

						<div class="col-12 col-md-6">
							<q-input v-model="organization.director" label="Директор, Ф.И.О." filled
								:rules="[val => !!val || 'Обязательное поле']" />
						</div>
						<div class="col-12 col-md-6">
							<q-input v-model="organization.glavbuh" label="Главный бухгалтер, Ф.И.О." filled
								:rules="[val => !!val || 'Обязательное поле']" />
						</div>
					</div>
				</q-form>
			</q-card-section>

			<q-card-actions align="right">
				<q-btn label="Сохранить" type="submit" color="primary" @click="onSubmit" />
			</q-card-actions>
		</q-card>
	</q-page>

</template>

<script>
import { apiUrl } from "../config";
import axios from "axios";
import { ref } from "vue";

export default {
	name: "manager_org",
	data() {
		axios
			.post(apiUrl + '/admin/manager/', {}, { auth: this.$store.state.credentials })
			.then((response) => {
				console.log(response)
				if (response.error !== undefined) {
					this.$q.notify({
						color: 'negative',
						message: 'Неизвестная ошибка',
						icon: 'error'
					})
				} else{
					this.organization = response.data.item;
				}
			})
			.catch((error) => {
				console.log(error)
				this.$q.notify({
					color: 'negative',
					message: 'Неизвестная ошибка',
					icon: 'error'
				})
			})
		return {
			organization: ref({
				id: 0,
				name: '',
				address: '',
				phone: '',
				inn: '',
				kpp: '',
				bank: '',
				bank_bik: '',
				bank_account: '',
				bank_account_ext: '',
				position_name: '',
				director: '',
				glavbuh: '',
			})
        }
	},
	methods: {
		onSubmit ()  {
			axios
				.post(apiUrl + '/admin/manager/save/', this.organization, { auth: this.$store.state.credentials })
				.then((response) => {
					console.log(response)
					this.$q.notify({
						color: 'positive',
						message: 'Данные успешно сохранены',
						icon: 'check'
					})
				})
				.catch((error) => {
					console.log(error)
					this.$q.notify({
						color: 'negative',
						message: 'Неизвестная ошибка',
						icon: 'error'
					})
				})
		}
	}
}
</script>

<style scoped>
.organization-card {
	width: 100%;
	max-width: 900px;
}

@media (max-width: 600px) {
	.organization-card {
		width: 95%;
	}
}
</style>